// extracted by mini-css-extract-plugin
export default {"simplefigure":"Figure_simplefigure__yGd7K","figure-title":"Figure_figure-title__a+39R"};